import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import { selectAuthAccountData } from 'mt-react-common/modules/users/common/reducers/states/authAccount';
import {
  setIsRightSidebar,
  selectIsRightSidebar
} from 'mt-react-common/reducer';

import ChangeEmailConfirmNoticeBlock from '../../UserAccount/Confirms/ConfirmNoticeBlocks/ChangeEmailConfirmNoticeBlock';
import FirstEmailConfirmNoticeBlock from '../../UserAccount/Confirms/ConfirmNoticeBlocks/FirstEmailConfirmNoticeBlock';
import EmailConfirmNoticeBlock from '../../UserAccount/Confirms/ConfirmNoticeBlocks/EmailConfirmNoticeBlock';

/**
 * hoc для обертки контента страницы, необходим чтобы централизировать управление контентами в одном месте.
 * */
export default function createColumnsContent(ContentMain, ContentRight) {
  class ColumnsContent extends React.Component {
    componentWillMount() {
      if (ContentRight && !this.props.isRightSidebar) {
        this.props.setIsRightSidebar(true);
      } else if (!ContentRight && this.props.isRightSidebar) {
        this.props.setIsRightSidebar(false);
      }
    }

    render() {
      const props = this.props;
      let confirmBlock = null;
      if (props.authAccountData.emailConfirm === 0) {
        confirmBlock = <FirstEmailConfirmNoticeBlock {...props} />;
      } else if (props.authAccountData.emailConfirm === 2) {
        confirmBlock = <ChangeEmailConfirmNoticeBlock {...props} />;
      } else if (props.authAccountData.emailConfirm === 3) {
        confirmBlock = <EmailConfirmNoticeBlock {...props} />;
      }
      if (ContentRight) {
        return (
          <React.Fragment>
            <div
              id="content"
              className="page-content col-xs-24 col-sm-18 col-md-14"
            >
              {confirmBlock}
              <ContentMain {...props} />
            </div>
            <div
              id="rightSidebar"
              className="page-sidebar page-sidebar_right col-md-5"
            >
              <ContentRight {...props} />
            </div>
          </React.Fragment>
        );
      }
      return (
        <div
          id="content"
          className="page-content col-xs-24 col-sm-18 col-md-19"
        >
          {confirmBlock}
          <ContentMain {...props} />
        </div>
      );
    }
  }

  ColumnsContent.displayName = `ColumnsContent`;

  ColumnsContent.propTypes = {
    authAccountData: PropTypes.shape({
      emailConfirm: PropTypes.number.isRequired
    }).isRequired,
    isRightSidebar: PropTypes.bool.isRequired,
    setIsRightSidebar: PropTypes.func.isRequired
  };

  const mapStateToProps = state => ({
    authAccountData: selectAuthAccountData(state),
    isRightSidebar: selectIsRightSidebar(state)
  });
  const mapDispatchToProps = dispatch => ({
    setIsRightSidebar: bool => dispatch(setIsRightSidebar(bool))
  });
  return withRouter(
    connect(
      mapStateToProps,
      mapDispatchToProps
    )(ColumnsContent)
  );
}



// WEBPACK FOOTER //
// ./src/components/Hocs/ColumnsContent/ColumnsContent.js